<template>
    <div class="bg-grey-light p-3 mb-3" v-if="showActionList">
        <div v-for="(action, key) in automationActions" class="mt-4">
            <div class="row my-3 align-items-center" v-if="action.action && action.actionObject">
                <div class="col-1">
                    <button class="btn btn-yellow mr-2 text-capitalize">{{ action.action ? action.action.replace('action_', '') : '' }}</button>
                </div>
                <div class="col-1">
                    <button class="btn btn-primary mr-2 text-capitalize">{{ action.actionObject ? action.actionObject.replace('action_', '') : ''}}</button>
                </div>
                <div class="col-10">
                    <div v-if="action.action === 'action_update'" class="flex align-items-center">
                        <div v-if="action.actionObject === 'action_sequence'" class="flex align-items-center">
                            <span class="mr-2">Sequence</span>
                            <button v-if="action.selectedSequenceName" type="button" class="btn btn-primary text-capitalize">{{ action.selectedSequenceName }}</button>
                        </div>
                        <div v-else>{{ formatAutomationData(action) }}</div>
                    </div>
                    <div v-if="action.action === 'action_email'" class="flex align-items-center">
                        <button v-if="action.actionObject !== 'action_contact'" type="button" class="btn btn-light-red mr-2">{{ action.actionObject === "action_non_user" ? (action.nonUserRecipientEmailAddresses.length ? action.nonUserRecipientEmailAddresses.map(item => item.email).join(', ') : '') : (action.emailActionDropDownValues.length ? action.emailActionDropDownValues.map(item => item.name).join(', ') : '') }}</button>
                        <div class="flex align-items-center">
                            <span class="mr-2">Template</span>
                            <button v-if="action.selectedTemplateName" type="button" class="btn btn-primary text-capitalize">{{ action.selectedTemplateName }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment/moment";
import ProjectRecordDetailFields from "../../../assets/fields-data/project-record-detail-fields.json";
import ProjectDataFields from "../../../assets/fields-data/project-data-fields.json";

export default {
    name: 'CreateEditAutomationActionList',
    props: ['team', 'automationActions', 'recordDetailFieldLabels', 'fieldLabels'],
    data() {
        return {
            showActionList: false
        }
    },
    watch: {
        automationActions: {
            handler: function() {
                this.manageActionListToggle();
            },
            deep: true
        }
    },
    mounted() {
        this.manageActionListToggle();
    },
    methods: {
        formatAutomationData(action) {
            let actionFieldName = null;

            let recordDetailField = _.find(ProjectRecordDetailFields, { property_name: action.actionField });
            let dataField = _.find(ProjectDataFields, { property_name: action.actionField });
            if(recordDetailField !== undefined) {
                actionFieldName = this.getFieldLabel(this.recordDetailFieldLabels, recordDetailField.id);
            }
            else if(dataField !== undefined) {
                actionFieldName = this.getFieldLabel(this.fieldLabels, dataField.id);
            }
            else {
                actionFieldName = action.actionField.replace(/_id$/, '');
                actionFieldName = _.startCase(actionFieldName && actionFieldName !== 'empty' ? actionFieldName : '-')
            }
            let actionValue = action.selectedActionValue ? action.selectedActionValue : action.inputActionValue;

            if(action.actionIsFixedDate === "fixed") {
                if(action.actionSalesBehaviorId || (action.actionCustomFieldId && action.actionFieldObject.type === "date") || (!action.actionSalesBehaviorId && !action.actionCustomFieldId && action.actionFieldObject.type === "date")) {
                    actionValue = (new Date(action.inputActionValue)).toUTCString();
                    actionValue = moment(actionValue).isValid() ? ((action.actionSalesBehaviorId && this.team.has_calendar_access) ? (moment(actionValue).utc().format('YYYY-MM-DD') + ' ' + (action.salesBehaviorHour + ':' + action.salesBehaviorMinute + ' ' + action.salesBehaviorAMPM)) : moment(actionValue).utc().format('YYYY-MM-DD')) : ''
                }
            }
            else if(action.actionIsFixedDate === "not_fixed") {
                if(action.actionSalesBehaviorId || (action.actionCustomFieldId && action.actionFieldObject.type === "date") || (!action.actionSalesBehaviorId && !action.actionCustomFieldId && action.actionFieldObject.type === "date")) {
                    actionValue = (action.actionSalesBehaviorId && this.team.has_calendar_access) ? action.inputActionValue + ' days (Time: ' + (action.salesBehaviorHour + ':' + action.salesBehaviorMinute + ' ' + action.salesBehaviorAMPM) + ') after automation triggered' : action.inputActionValue + ' days after automation triggered';
                }
            }

            if(action.actionIsFixedDate === "clear_date_time") {
                return actionFieldName + ' date and time will be cleared out';
            }
            else {
                if(action.actionField === 'gross_margin_percentage') {
                    actionValue = actionValue + '%';
                }
                return 'Set ' + actionFieldName + ' to ' + (actionValue ?? '-');
            }
        },
        manageActionListToggle() {
            this.showActionList = this.automationActions.length > 0 && this.automationActions[0] !== undefined &&
                this.automationActions[0].action && this.automationActions[0].actionObject && this.automationActions[0].actionField &&
                this.automationActions[0].actionField !== "empty" && (this.automationActions[0].inputActionValue || (this.automationActions[0].actionSalesBehaviorId && this.automationActions[0].actionIsFixedDate === 'clear_date_time'))
        }
    }
}
</script>

<style scoped>
.btn-light-red {
    background: #f87676;
}
.btn-purple {
    background: #6e7ff2;
}
.btn-yellow {
    background: #f8f582;
}
</style>
